export default __webpack_public_path__ + "static/media/pyuuromi.97eacad3.jpeg";